<template>
  <div id="welcome">
    <div id="welcome-content">
      <div id="txt">
        <div id="a">
          Üdvözöljük a
          <span>NEMZETI TANKÖNYV</span> művészeti projekt archívumának oldalán!
          <br>Itt külföldi középiskolai tankönyvek Magyarországra vonatkozó részei között lehet böngészni.
          Az anyag nem teljes és nem tudományos igényű, hiszen egy művészeti kezdeményezés oldal projektje,
          de úgy véljük, mégis érdekes lehet itt is kutakodni a téma iránt érdeklődőknek.
          <br>A projektről bővebb információ ezen a címen található:
          <a
            href="http://nationaltextbook.hu"
            target="_blank"
            style="color: #000000; text-decoration: none;"
          >nationaltextbook.hu</a>
        </div>
        <div id="b">Válasszon évszámot!</div>
      </div>
      <div id="img"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Welcome",
  data() {
    return {};
  }
};
</script>

<style scoped>
#welcome {
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 230px);
  background-image: url("~@/assets/ntk_welcome_bg.jpg");
  background-position: center center;
  background-size: cover;
  animation: welcome 1000ms ease-in-out forwards;
}

#welcome-content {
  padding: 30px;
  width: 75%;
  height: 75%;
  background-color: rgba(255, 255, 255, 0.75);
  opacity: 0;
  animation: welcome 1000ms ease-in-out forwards;
  animation-delay: 500ms;
}

#txt,
#img {
  float: left;
  width: calc(50% - 15px);
  height: 100%;
  overflow: hidden;
}

#txt {
  position: relative;
  padding-right: 15px;
}

#a,
#b {
  position: absolute;
  font-size: 14px;
}

#a {
  width: 100%;
  font-weight: 700;
}

#b {
  border: 4px solid #000000;
  padding: 15px;
  bottom: 0;
  font-weight: 900;
}

#img {
  position: relative;
  margin-left: 30px;
  background-image: url("~@/assets/ntk_welcome_img.jpg");
  background-position: center top;
  background-size: cover;
}

@media only screen and (max-width: 840px) {
  #welcome {
    height: calc(100vh - 230px);
  }

  #welcome-content {
    width: 100%;
    height: 100%;
  }

  #txt,
  #img {
    width: 100%;
    height: 50%;
    padding: 0;
  }

  #txt {
    display: flex;
    justify-content: center;
  }

  #b {
    margin-bottom: 15px;
    width: 100%;
    text-align: center;
  }
}

@media only screen and (max-width: 600px) {
  #welcome {
    height: calc(100vh - 250px);
  }

  #welcome-content {
    padding: 15px;
  }

  #a,
  #b {
    font-size: 12px;
  }
}

@keyframes welcome {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>

